import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';

var root = $.from_html(`<option class="svelte-4lm3n7qjzgcd"> </option>`);
var root_1 = $.from_html(`<label class="row svelte-4lm3n7qjzgcd"><span class="label svelte-4lm3n7qjzgcd"> </span> <select class="svelte-4lm3n7qjzgcd"></select></label>`);

export default function Select($$anchor, $$props) {
	$.push($$props, true);

	var label = root_1();
	var span = $.child(label);
	var text = $.child(span, true);

	$.reset(span);

	var select = $.sibling(span, 2);

	$.each(select, 21, () => $$props.spec.options, (o) => o.value, ($$anchor, o) => {
		var option = root();
		var text_1 = $.child(option, true);

		$.reset(option);

		var option_value = {};

		$.template_effect(() => {
			$.set_text(text_1, $.get(o).label);

			if (option_value !== (option_value = $.get(o).value)) {
				option.value = (option.__value = $.get(o).value) ?? '';
			}
		});

		$.append($$anchor, option);
	});

	$.reset(select);

	var select_value;

	$.init_select(select);
	$.reset(label);

	$.template_effect(() => {
		$.set_text(text, $$props.spec.label);

		if (select_value !== (select_value = $$props.value)) {
			(
				select.value = (select.__value = $$props.value) ?? '',
				$.select_option(select, $$props.value)
			);
		}
	});

	$.delegated('change', select, (e) => $$props.onchange(e.currentTarget.value));
	$.append($$anchor, label);
	$.pop();
}

$.delegate(['change']);
import "bun-svelte:Select.svelte-x1m59881iuc5-style.css";